<script lang="ts">
  import Checkbox from '$shared/atoms/Checkbox/Checkbox.svelte';
  import Dropdown from '$shared/atoms/Dropdown/Dropdown.svelte';
  import type { MonitorOption } from '$shared/components/types';
  import { data } from '$provider/lib/datas';
  import { MonitorIntervalHelper } from '$shared/helpers/MonitorIntervalHelper';
  import { onMount } from 'svelte';

  const DefaultMonitoringDesc = `We'll automatically re-check this provider's records and alert you of any changes`;

  interface Props {
    option?: MonitorOption;
    disabled?: boolean;
    content?: import('svelte').Snippet;
    oncheck?: (e: any) => void;
    oninterval?: (detail: any) => void;
  }

  let {
    option = {} as MonitorOption,
    disabled = false,
    content,
    oncheck,
    oninterval
  }: Props = $props();

  let defaultMonitoringInterval = $derived(
    option?.defaultInterval || data.MonitoringInterval.Monthly
  );
  let dropdownDisabled = $derived(disabled || !option?.config?.enableMonitoring);
  let dropdownLabel = $derived(option?.config?.monitoringInterval || defaultMonitoringInterval);
  let enabled = $derived(option?.config?.enableMonitoring);

  let hasOnlyOneInterval = $state(false);

  onMount(() => {
    hasOnlyOneInterval = option?.intervals?.length === 1;
    hasOnlyOneInterval && oninterval?.(option?.intervals?.first());
  });

  const onCheckboxChange = (e: any): void => {
    oncheck?.(e);
  };
  const onIntervalChange = (detail: any): void => {
    oninterval?.(detail);
  };
</script>

<div class="monitor-container">
  <div class="input">
    <div class="checkbox">
      <Checkbox
        name={`${option?.name}-m`}
        label="Monitor this record"
        checked={enabled}
        {disabled}
        onchange={onCheckboxChange}
      />
    </div>
    {#if hasOnlyOneInterval}
      <div class="label">{option?.intervals?.first()?.label || defaultMonitoringInterval}</div>
    {:else}
      <div data-cy={`${option?.name}-monitor-dropdown`} class="dropdown">
        <Dropdown
          name="monitorInterval"
          disabled={dropdownDisabled}
          label={dropdownLabel}
          list={option?.intervals || MonitorIntervalHelper.getList(defaultMonitoringInterval)}
          onchange={onIntervalChange}
        />
      </div>
    {/if}
    {#if option?.includeExpiring}
      <div class="text">and when expiring</div>
    {/if}
  </div>
  <div class="desc">{DefaultMonitoringDesc}</div>
  {@render content?.()}
</div>

<style>
  .monitor-container {
    background-color: var(--grey-bg);
    padding: 16px;
    border-radius: 5px;
  }
  .input {
    display: flex;
    align-items: center;
  }
  .checkbox {
    padding-right: 8px;
  }
  .text {
    margin-left: 5px;
    font-weight: normal;
    font-size: 14px;
    line-height: 22px;
    color: var(--grey-dark);
  }
  .desc {
    font-weight: normal;
    font-size: 11px;
    line-height: 18px;
    color: var(--grey-medium);
    padding-left: 24px;
    margin-top: 4px;
  }
  .label {
    font-weight: 500;
  }
</style>
